import { getTypographyMetric, getTypographyMetricOverride } from '../../../../../../../../../../helpers';
import { useTheme } from 'styled-components';
import { Button } from 'front-commons/ds/components/Button';
import { Flex } from 'front-commons/ds/components/Flex';
import { Icon } from 'front-commons/ds/components/Icon';
import { Typography } from 'hype-ds';
import { MenuButtonProps } from './interfaces';

export function MenuButton({ onClick, name, selected }: MenuButtonProps) {
	const { fontSizes } = useTheme();

	return (
		<Flex
			raw={{
				"[data-header-text='MenuButton-text-1']": {
					display: 'inline',
					fontSize: getTypographyMetricOverride(fontSizes['16']),
					lineHeight: getTypographyMetricOverride(fontSizes['24']),
				},
				'&&': { borderRadius: '0', borderBottom: '1px solid var(--border-disable)' },
			}}
			alignItems="center"
			width="100%"
			justifyContent="space-between !important"
			height="48px !important"
			padding="8px 12px !important"
			as={Button}
			variant="none"
			onClick={onClick}
			borderRadius={'0'}
		>
			<Typography
				textAlign="inherit"
				fontSize={getTypographyMetric(fontSizes['16'])}
				fontWeight="600"
				lineHeight={getTypographyMetric(fontSizes['24'])}
				color={selected ? '--greys-900' : '--hympar-blue-700'}
				data-header-text="MenuButton-text-1"
			>
				{name}
			</Typography>

			<Icon name="chevron_right" color="--text-link" size="24px" />
		</Flex>
	);
}
